import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Shippingreturnpage.css";

const CloseIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#003049" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);

export default function Shippingreturnpage({ onBack }) {
  const navigate = useNavigate();
  
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleClose = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/");
    }
  };

  return (
    <div className="shipping-page">
      <div className="shipping-header">
        <div className="shipping-header-spacer"></div>
        <h2 className="shipping-header-title">Payments, Return and Shipping Policy</h2>
        <button onClick={handleClose} className="shipping-close-btn" aria-label="Close">
            <CloseIcon />
        </button>
      </div>

      <div className="shipping-content">
        <h1 className="shipping-doc-title">WorldofNABI | Payments, Shipping & Returns Policy</h1>
        <p className="shipping-meta">We want your shopping experience with <strong>WorldofNABI</strong> to be smooth and stress-free. Here’s everything you need to know about paying, getting your goodies, and returning them if needed.</p>

        <h3 className="shipping-section-title">1. Payments</h3>
        <ul className="shipping-list">
            <li><strong>Accepted Methods:</strong> We accept payments through (Credit/Debit Cards, UPI, Net Banking, Wallets, PayPal, etc.).</li>
            <li><strong>Currency:</strong> All transactions are processed in INR. International customers may incur conversion fees from their bank.</li>
            <li><strong>Payment Security:</strong> Transactions are encrypted and processed securely through our payment gateway partners. We do not store sensitive card details.</li>
            <li><strong>Order Confirmation:</strong> You will receive an email/SMS confirmation once your payment is successfully processed.</li>
        </ul>

        <h3 className="shipping-section-title">2. Shipping</h3>
        <ul className="shipping-list">
            <li><strong>Delivery Locations:</strong> We currently ship within India / worldwide—specify regions.</li>
            <li><strong>Processing Time:</strong> Orders are typically processed within 2–5 business days. Custom or pre-order items may take longer, and this will be clearly indicated at checkout.</li>
            <li><strong>Delivery Time:</strong> Standard delivery takes 7-15 business days within India / 10–20 business days for international orders. Delivery timelines may vary due to courier delays, customs, or unforeseen circumstances.</li>
            <li><strong>Shipping Charges:</strong>
                <ul>
                    <li>Standard Shipping: ₹100 flat fee. Free for orders above ₹1000.</li>
                    <li>International Shipping: Charges calculated at checkout based on location and package weight.</li>
                </ul>
            </li>
            <li><strong>Tracking:</strong> A tracking link will be shared once your order is dispatched.</li>
            <li><strong>Responsibility:</strong> We are not responsible for delays caused by courier partners, incorrect addresses, or factors beyond our control.</li>
        </ul>
       
        <h3 className="shipping-section-title">3. Returns & Exchanges</h3>
        <p>We want you to love your purchase. If you are not satisfied, please review our return and exchange rules:</p>
        <ul className="shipping-list">
            <li><strong>Eligibility:</strong>
                <ul>
                    <li>Returns/exchanges accepted within 14 days of delivery.</li>
                    <li>Items must be unused, worn, unwashed, and in original packaging with tags intact.</li>
                    <li>Certain products (e.g., digital downloads, opened wellness items, personal care products) are non-returnable for hygiene/safety reasons.</li>
                </ul>
            </li>

            <li><strong>Process:</strong>
                <ul>
                    <li>Email us at contactworldofnabi@gmail.com with your order number and reason for return.</li>
                    <li>Once approved, ship the item back to us at your own cost unless the product was defective/damaged.</li>
                    <li>After inspection, we will process your refund/exchange.</li>
                </ul>
            </li>

            <li><strong>Refunds:</strong>
                <ul>
                    <li>Refunds are issued to the original payment method within 7–10 business days of approval.</li>
                    <li>Shipping charges are non-refundable unless the return is due to our error.</li>
                </ul>
            </li>

            <li><strong>Exchanges:</strong>
                <ul>
                    <li>Exchanges are subject to stock availability. If unavailable, a refund or store credit will be provided.</li>
                </ul>
            </li>

            <li><strong>Damaged or Wrong Items:</strong>
                <ul>
                    <li>If you receive a defective or incorrect product, contact us within [48 hours] of delivery with photos, and we’ll arrange a replacement or refund at no extra cost.</li>
                </ul>
            </li>
        </ul>

        <h3 className="shipping-section-title">4. Contact Us</h3>
        <p>For payments, shipping, or return-related questions, reach us at:</p>
        <ul className="shipping-list">
            <li>contactworldofnabi@gmail.com</li>
            <li>6309960077</li>
            <li>[Insert company address]</li>
        </ul>
      </div>
    </div>
  );
}